module.exports = __webpack_public_path__ + "static/iwth-en-footer-5529c2a4dd84e3fb58958b06da66d384.svg";